import {CHALLENGE_MADE, CARD_LOOKUP_REQUEST_FAIL, CARD_LOOKUP_REQUEST_SENT, CARD_LOOKUP_REQUEST_SUCCESS,
        UPDATE_CAVV, UPDATE_ECI, AUTH_REQUEST_FAIL, AUTH_REQUEST_SENT, AUTH_REQUEST_SUCCESS,
        CAVV_LOOKUP_REQUEST_FAIL, CAVV_LOOKUP_REQUEST_SENT, CAVV_LOOKUP_REQUEST_SUCCESS,
        CAVV_PURCHASE_REQUEST_FAIL, CAVV_PURCHASE_REQUEST_SENT, CAVV_PURCHASE_REQUEST_SUCCESS,
        CAVV_PREAUTH_REQUEST_FAIL, CAVV_PREAUTH_REQUEST_SENT, CAVV_PREAUTH_REQUEST_SUCCESS,
        UPDATE_CHALLENGE_DATA, UPDATE_CHALLENGE_URL, _3DS2, TOGGLE_CHALLENGE_IFRAM,
        RES_CAVV_PURCHASE_REQUEST_SUCCESS, RES_CAVV_PURCHASE_REQUEST_SENT, RES_CAVV_PURCHASE_REQUEST_FAIL,
        CAVV_PURCHASE_REC_REQUEST_SUCCESS, CAVV_PURCHASE_REC_REQUEST_SENT, CAVV_PURCHASE_REC_REQUEST_FAIL,
        RES_CAVV_PREAUTH_REQUEST_SUCCESS, RES_CAVV_PREAUTH_REQUEST_SENT, RES_CAVV_PREAUTH_REQUEST_FAIL,
} from './types'

const HOST = "https://developer.moneris.com/demoapi"
//http://monerisdeveloperauth.monad.moneris.com:8081
//https://localhost:5001
//https://developer.moneris.com:8081

export const challengeMade = () => dispatch => {
    dispatch({ feature: _3DS2, type: CHALLENGE_MADE });
}

export const toggleChallengeIfram = (value) => dispatch => {
    dispatch({ feature: _3DS2, type: TOGGLE_CHALLENGE_IFRAM, payload: value});
}

export const makeCardLookupRequest = (cardLookupRequest) => async dispatch => {
    dispatch({ feature: _3DS2, type: CARD_LOOKUP_REQUEST_SENT });
    const { storeId, apiToken, order_id, pan } = cardLookupRequest;

    try {
        let response = await fetch(`${HOST}/api/threedstwo/cardlookup`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            // mode: 'no-cors',
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                pan: pan,
                notification_url: `${HOST}/api/threedstwo/getcres`
            }),
        })

        let responseJson = await response.json();
        var output = "";
        output += "ResponseCode = " + responseJson.ResponseCode + '\n';
        output += "ReceiptId = " + responseJson.ReceiptId + '\n';
        output += "Message = " + responseJson.Message + '\n';
        output += "Messagetype = " + responseJson.Messagetype + '\n';
        output += "ThreeDSMethodURL = " + responseJson.ThreeDSMethodURL + '\n';
        output += "ThreeDSMethodData = " + responseJson.ThreeDSMethodData + '\n';
        output += "ThreeDSServerTransID = " + responseJson.ThreeDSServerTransID;

        if(responseJson.Message !== "SUCCESS") {
            dispatch({ feature: _3DS2, type: CARD_LOOKUP_REQUEST_FAIL, payload: output});
            return;
        }

        dispatch({ feature: _3DS2, type: CARD_LOOKUP_REQUEST_SUCCESS, payload: output });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _3DS2, type: CARD_LOOKUP_REQUEST_FAIL, payload: 'Error, please try again.'});
    }
}

export const make3DSAuthRequest = (threeDSAuthRequest) => async dispatch => {
    dispatch({ feature: _3DS2, type: AUTH_REQUEST_SENT });
    
    const { storeId, apiToken, order_id, pan, expdate, amount, currency} = threeDSAuthRequest
    try {
        let response = await fetch(`${HOST}/api/threedstwo/threedsauthentication`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                pan: pan,
                expdate: expdate,
                amount: amount,
                notification_url: `${HOST}/api/threedstwo/getcres`,
                currency: currency
            }),
        })

        let responseJson = await response.json();
        var output = "";
        output += "ResponseCode = " + responseJson.ResponseCode + '\n';
        output += "ReceiptId = " + responseJson.ReceiptId + '\n';
        output += "Message = " + responseJson.Message + '\n';
        output += "Messagetype = " + responseJson.Messagetype + '\n';
        output += "TransStatus = " + responseJson.TransStatus + '\n';
        output += "ChallengeURL = " + responseJson.ChallengeURL + '\n';
        output += "ChallengeData = " + responseJson.ChallengeData + '\n';
        output += "ThreeDSServerTransID = " + responseJson.ThreeDSServerTransID + '\n';
        output += "Cavv = " + responseJson.Cavv + '\n';
        output += "ECI = " + responseJson.ECI + '\n';

        if(responseJson.Message !== "SUCCESS") {
            dispatch({ feature: _3DS2, type: AUTH_REQUEST_FAIL, payload: output});
            return;
        }

        dispatch({ feature: _3DS2, type: AUTH_REQUEST_SUCCESS, payload: output });
        dispatch({ feature: _3DS2, type: UPDATE_CHALLENGE_URL, payload: responseJson.ChallengeURL });
        dispatch({ feature: _3DS2, type: UPDATE_CAVV, payload: responseJson.Cavv });
        dispatch({ feature: _3DS2, type: UPDATE_ECI, payload: responseJson.ECI });
        if(responseJson.TransStatus === "C") {
            dispatch({ feature: _3DS2, type: UPDATE_CHALLENGE_DATA, payload: responseJson.ChallengeData });
        }
        else {
            dispatch({ feature: _3DS2, type: UPDATE_CHALLENGE_DATA, payload: "null" });
        }
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _3DS2, type: AUTH_REQUEST_FAIL, payload: 'Error, please try again.'});
    }   
}

export const makeCavvLookupRequest = ({ storeId, apiToken }) => async dispatch => {
    dispatch({ feature: _3DS2, type: CAVV_LOOKUP_REQUEST_SENT });
    
    try {
        let response = await fetch(`${HOST}/api/threedstwo/cavvlookup`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
            }),
        })

        let responseJson = await response.json();
        var output = "";
        output += "ResponseCode = " + responseJson.ResponseCode + '\n';
        output += "ReceiptId = " + responseJson.ReceiptId + '\n';
        output += "Message = " + responseJson.Message + '\n';
        output += "ThreeDSServerTransID = " + responseJson.ThreeDSServerTransID + '\n';
        output += "TransStatus = " + responseJson.TransStatus + '\n';
        output += "ChallengeCompletionIndicator = " + responseJson.ChallengeCompletionIndicator + '\n';
        output += "Cavv = " + responseJson.Cavv + '\n';
        output += "ECI = " + responseJson.ECI + '\n';

        dispatch({ feature: _3DS2, type: UPDATE_CAVV, payload: responseJson.Cavv });
        dispatch({ feature: _3DS2, type: UPDATE_ECI, payload: responseJson.ECI });
        dispatch({ feature: _3DS2, type: CAVV_LOOKUP_REQUEST_SUCCESS, payload: output });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _3DS2, type: CAVV_LOOKUP_REQUEST_FAIL, payload: 'Error, please try again.'});
    }   
}

export const makeCavvPurchaseRequest = (cavvPurchaseRequest) => async dispatch => {
    dispatch({ feature: _3DS2, type: CAVV_PURCHASE_REQUEST_SENT });
    const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci} = cavvPurchaseRequest;
    
    try {
        let response = await fetch(`${HOST}/api/threedstwo/cavvpurchase`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                amount: amount,
                pan: pan,
                expdate: expdate,
                cavv: cavv,
                eci: eci,
            }),
        })

        let responseJson = await response.json();
        var output = "";
        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount + '\n';
        output += "TxnNumber = " + responseJson.TxnNumber + '\n';
        output += "ReceiptId = " + responseJson.ReceiptId + '\n';
        output += "TransType = " + responseJson.TransType + '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum + '\n';
        output += "ResponseCode = " + responseJson.ResponseCode + '\n';
        output += "ISO = " + responseJson.ISO + '\n';
        output += "BankTotals = " + responseJson.BankTotals + '\n';
        output += "Message = " + responseJson.Message + '\n';
        output += "AuthCode = " + responseJson.AuthCode + '\n';
        output += "Complete = " + responseJson.Complete + '\n';
        output += "TransDate = " + responseJson.TransDate + '\n';
        output += "TransTime = " + responseJson.TransTime + '\n';
        output += "Ticket = " + responseJson.Ticket + '\n';
        output += "TimedOut = " + responseJson.TimedOut + '\n';
        output += "CavvResultCode = " + responseJson.CavvResultCode + '\n';
        output += "IssuerId = " + responseJson.IssuerId + '\n';
        output += "ThreeDSVersion = " + responseJson.ThreeDSVersion + '\n';

        dispatch({ feature: _3DS2, type: CAVV_PURCHASE_REQUEST_SUCCESS, payload: output });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _3DS2, type: CAVV_PURCHASE_REQUEST_FAIL, payload: 'Error, please try again.'});
    }   
}

export const makeResCavvPurchaseRequest = (resCavvPurchaseRequest) => async dispatch => {
    dispatch({ feature: _3DS2, type: RES_CAVV_PURCHASE_REQUEST_SENT });
    const { storeId, apiToken, order_id, expdate, amount, cavv} = resCavvPurchaseRequest;
    
    try {
        let response = await fetch(`${HOST}/api/threedstwo/rescavvpurchase`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                amount: amount,
                expdate: expdate,
                cavv: cavv,
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _3DS2, type: RES_CAVV_PURCHASE_REQUEST_FAIL, payload: output });
            return;
        }

        dispatch({ feature: _3DS2, type: RES_CAVV_PURCHASE_REQUEST_SUCCESS, payload: output });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _3DS2, type: RES_CAVV_PURCHASE_REQUEST_FAIL, payload: 'Error, please try again.'});
    }   
}

export const makeCavvPurchaseRecRequest = (cavvPurchaseRecRequest) => async dispatch => {
    dispatch({ feature: _3DS2, type: CAVV_PURCHASE_REC_REQUEST_SENT });
    const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci} = cavvPurchaseRecRequest;

    console.log(expdate);
    
    try {
        let response = await fetch(`${HOST}/api/threedstwo/cavvpurchaserec`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                amount: amount,
                pan: pan,
                expdate: expdate,
                cavv: cavv,
                eci: eci,
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _3DS2, type: CAVV_PURCHASE_REC_REQUEST_FAIL, payload: output });
            return;
        }

        dispatch({ feature: _3DS2, type: CAVV_PURCHASE_REC_REQUEST_SUCCESS, payload: output });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _3DS2, type: CAVV_PURCHASE_REC_REQUEST_FAIL, payload: 'Error, please try again.'});
    }   
}

export const makeCavvPreAuthRequest = (cavvPreAuthRequest) => async dispatch => {
    dispatch({ feature: _3DS2, type: CAVV_PREAUTH_REQUEST_SENT });
    const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci} = cavvPreAuthRequest;
    
    try {
        let response = await fetch(`${HOST}/api/threedstwo/cavvpreauth`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                amount: amount,
                pan: pan,
                expdate: expdate,
                cavv: cavv,
                eci: eci,
            }),
        })

        let responseJson = await response.json();
        var output = "";
        output += "CardType = " + responseJson.CardType + '\n';
        output += "TransAmount = " + responseJson.TransAmount + '\n';
        output += "TxnNumber = " + responseJson.TxnNumber + '\n';
        output += "ReceiptId = " + responseJson.ReceiptId + '\n';
        output += "TransType = " + responseJson.TransType + '\n';
        output += "ReferenceNum = " + responseJson.ReferenceNum + '\n';
        output += "ResponseCode = " + responseJson.ResponseCode + '\n';
        output += "ISO = " + responseJson.ISO + '\n';
        output += "BankTotals = " + responseJson.BankTotals + '\n';
        output += "Message = " + responseJson.Message + '\n';
        output += "AuthCode = " + responseJson.AuthCode + '\n';
        output += "Complete = " + responseJson.Complete + '\n';
        output += "TransDate = " + responseJson.TransDate + '\n';
        output += "TransTime = " + responseJson.TransTime + '\n';
        output += "Ticket = " + responseJson.Ticket + '\n';
        output += "TimedOut = " + responseJson.TimedOut + '\n';
        output += "CavvResultCode = " + responseJson.CavvResultCode + '\n';
        output += "IssuerId = " + responseJson.IssuerId + '\n';
        output += "ThreeDSVersion = " + responseJson.ThreeDSVersion + '\n';

        dispatch({ feature: _3DS2, type: CAVV_PREAUTH_REQUEST_SUCCESS, payload: output });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _3DS2, type: CAVV_PREAUTH_REQUEST_FAIL, payload: 'Error, please try again.'});
    }   
}

export const makeResCavvPreAuthRequest = (resCavvPreAuthRequest) => async dispatch => {
    dispatch({ feature: _3DS2, type: RES_CAVV_PREAUTH_REQUEST_SENT });
    const { storeId, apiToken, order_id, expdate, amount, cavv} = resCavvPreAuthRequest;
    
    try {
        let response = await fetch(`${HOST}/api/threedstwo/rescavvpreauth`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: order_id,
                amount: amount,
                expdate: expdate,
                cavv: cavv,
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _3DS2, type: RES_CAVV_PREAUTH_REQUEST_FAIL, payload: output });
            return;
        }

        dispatch({ feature: _3DS2, type: RES_CAVV_PREAUTH_REQUEST_SUCCESS, payload: output });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _3DS2, type: RES_CAVV_PREAUTH_REQUEST_FAIL, payload: 'Error, please try again.'});
    }   
}



